/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dull_Seemly_Whale_LoveInputs */

const es_dull_seemly_whale_love = /** @type {(inputs: Dull_Seemly_Whale_LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motora`)
};

const gl_dull_seemly_whale_love = /** @type {(inputs: Dull_Seemly_Whale_LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motora`)
};

const en_dull_seemly_whale_love = /** @type {(inputs: Dull_Seemly_Whale_LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MotorBoat`)
};

/**
* | output |
* | --- |
* | "MotorBoat" |
*
* @param {Dull_Seemly_Whale_LoveInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const dull_seemly_whale_love = /** @type {((inputs?: Dull_Seemly_Whale_LoveInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dull_Seemly_Whale_LoveInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_dull_seemly_whale_love(inputs)
	if (locale === "en") return en_dull_seemly_whale_love(inputs)
	return es_dull_seemly_whale_love(inputs)
});